exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cbp-tm-menu{cursor:pointer}.studentPermissionsTooltip .tooltiptext{visibility:hidden;background-color:#000;color:#fff;text-align:center;border-radius:6px;padding:5px 0;position:absolute;z-index:1}.studentPermissionsTooltip:hover .tooltiptext{visibility:visible}", ""]);

// exports
